var _circle, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreenShadowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 334,
    height: 462,
    viewBox: "0 0 334 462",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.47,
    cx: 231,
    cy: 231,
    r: 231,
    fill: "url(#paint0_radial_36_161)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_36_161",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(231 231) rotate(90) scale(231)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9CDE99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7DBC79",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenShadowRight);
export default __webpack_public_path__ + "static/media/green_shadow-right.a796443f23a9e53e93a69e131e0d646d.svg";
export { ForwardRef as ReactComponent };